import { render } from "./TableShowForRepairRecordList.vue?vue&type=template&id=08803042&scoped=true"
import script from "./TableShowForRepairRecordList.vue?vue&type=script&lang=js"
export * from "./TableShowForRepairRecordList.vue?vue&type=script&lang=js"

import "./TableShowForRepairRecordList.vue?vue&type=style&index=0&id=08803042&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08803042"]])

export default __exports__